import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import {
  SelectField,
  TextInputField,
} from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useDispatcherUser from '../../../hooks/user/useDispatcherUser';
import useListWarehouses from '../../../hooks/warehouse/useListWarehouse';
import {
  DispatcherUserDataType,
  DispatcherUserInitialValues,
  DispatcherUserSchema,
  IDispatcherUserRequest,
} from '../../../models/user/dispatcherUser.model';

const CreateDispatcherModal = () => {
  const { createDispatcherUser, loading } = useDispatcherUser();
  const { listOfWarehouses } = useListWarehouses();

  const onSubmit = (values: DispatcherUserDataType, actions: any) => {
    // console.log(values);
    const data: IDispatcherUserRequest = {
      ...values,
      role: 'DISPATCHER',
      phoneNumber: '234' + values.phoneNumber.slice(1),
      warehouseId: listOfWarehouses.filter(
        (data: any) => data.name === values.warehouseId
      )[0].id,
    };

    createDispatcherUser(data);

    // if (resetInputFields) {
    actions.resetForm(DispatcherUserInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Create Dispatcher'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={DispatcherUserInitialValues}
          schema={DispatcherUserSchema}
          onSubmit={onSubmit}
        >
          <TextInputField
            label="User Name"
            name="userName"
            type="text"
            placeholder="User Name"
            className="full"
          />
          <TextInputField
            label="Phone Number"
            name="phoneNumber"
            type="text"
            placeholder="Phone Number"
            className="full"
          />
          <TextInputField
            label="Contact Person Email"
            name="email"
            type="email"
            placeholder="Contact Person Email"
            className="full"
          />

          <TextInputField
            label="First Name"
            name="firstName"
            type="text"
            placeholder="First Name"
            className="full"
          />
          <TextInputField
            label="Last Name"
            name="lastName"
            type="text"
            placeholder="Last Name"
            className="full"
          />
          <SelectField label="Warehouse" name="warehouseId">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Warehouse'}
            </option>
            {listOfWarehouses &&
              listOfWarehouses.map((data: any, index: number) => (
                <option key={index}>{data.name}</option>
              ))}
          </SelectField>

          <SelectField label="Vehicle Type" name="vehicleType">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Vehicle Type'}
            </option>
            <option>BIKE</option>
            <option>CAR</option>
            <option>TRUCK</option>
          </SelectField>

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Create Dispatcher
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default CreateDispatcherModal;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
